import { css } from "@emotion/react";
import { useEffect } from "react";
import * as React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";

import Redirect from "components/Redirect";
import { SafeIframe } from "components/safe-iframe/SafeIframe";
import { IFRAME_SCOPES } from "constants/integration-widget";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { SettingsRoutes } from "routes/settings/constants";
import {
  ApplicationWidgetPlacement,
  IWithApplicationsState,
  canManageApplications,
  getApplicationBySlug,
} from "store/entities/applications";

import ApplicationSettingsContainer from "../../components/ApplicationSettingsContainer";

import { DefaultSettings } from "./DefaultSettings";

const iframeCss = css`
  width: 100%;
  height: 100%;
  outline: none;
  border: 0;
`;

const ApplicationSettings: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const application = useSelector((state: IWithApplicationsState) => getApplicationBySlug(state, slug));
  const canManageApps = useSelector(canManageApplications);
  useEffect(() => {
    if (!application || !canManageApps) {
      return;
    }
    trackEngagement("Integrations: App details opened", EventPlace.AppDetails, { appName: application.name });
  }, [application, canManageApps]);

  if (!application || !canManageApps) {
    return <Redirect to={SettingsRoutes.Integrations} />;
  }
  const widgets = Object.values(application?.elements?.widgets || {});
  const settingsWidgetUrl = widgets.find(({ placement }) => placement === ApplicationWidgetPlacement.Settings)?.url;

  if (settingsWidgetUrl) {
    return (
      <ApplicationSettingsContainer application={application}>
        <SafeIframe css={iframeCss} title={application.name} src={settingsWidgetUrl} allow={IFRAME_SCOPES} />
      </ApplicationSettingsContainer>
    );
  }

  return <DefaultSettings application={application} />;
};

export default ApplicationSettings;
